import type { BrannanNavigation, DesignLayoutType } from '@graphql/generated-base';
import React, { createContext, useContext, useMemo } from 'react';

export type LayoutContextValue = Readonly<{
  layout: DesignLayoutType;
  brannanNavigation?: BrannanNavigation;
}>;

export const LayoutContext = createContext<LayoutContextValue | undefined>(undefined);

export const LayoutProvider: React.FC<{ layout: DesignLayoutType; brannanNavigation?: BrannanNavigation }> = ({ children, layout, brannanNavigation }) => {
  // A fresh object literal here re-rendered all ~30 useLayout consumers — including the largest
  // page widgets — every time this provider's parent rendered, regardless of memo boundaries.
  const value = useMemo<LayoutContextValue>(() => ({ layout, brannanNavigation }), [layout, brannanNavigation]);
  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
